"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ComponentException"));

var _StringUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/StringUtility"));

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Component prop handler.
 */
var ComponentPropHandler = /*#__PURE__*/function (_EventHandler) {
  _inherits(ComponentPropHandler, _EventHandler);

  var _super = _createSuper(ComponentPropHandler);

  /**
   * Class constructor.
   *
   * @param {object} options Options object.
   * @param {SupportedProp[]} options.supportedProps Supported props.
   * @param {Element} options.element DOM Element.
   * @param {string} options.componentName Component name.
   * @param {CacheStore} options.cacheStore Cache store.
   * @param {Function} options.objectParser Parser function for objects. Example: (methodName, value) => { if(this[methodName]) { return this[methodName](value); }}.
   */
  function ComponentPropHandler(options) {
    var _this;

    _classCallCheck(this, ComponentPropHandler);

    _this = _super.call(this, {
      supportedEvents: ['propsWillChange', 'propsHasChanged'],
      componentName: options.componentName
    });
    _this.props = {};
    _this.defaultedAttributes = {};
    _this._supportedProps = new Map();
    _this._attributes = {};
    _this._updatedProps = {};
    _this._storedProps = {};
    _this._element = options.element;
    _this._componentName = options.componentName;
    _this._cacheStore = options.cacheStore;
    _this._objectParser = options.objectParser;

    var _iterator = _createForOfIteratorHelper(options.supportedProps),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var supportedProp = _step.value;
        _this.props[supportedProp.name] = supportedProp.defaultValue;

        _this._supportedProps.set(supportedProp.name, supportedProp);

        if (supportedProp.defaultValue !== null) {
          _this.defaultedAttributes[supportedProp.attributeName] = true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _this;
  }
  /**
   * Updates attribute props.
   *
   * @throws ComponentException
   * @returns {boolean} TRUE if changed.
   */


  _createClass(ComponentPropHandler, [{
    key: "updatePropsFromElement",
    value: function updatePropsFromElement() {
      var newProps = {};
      this.updateStoredProps(this._element.getAttribute('data-props'));

      var _iterator2 = _createForOfIteratorHelper(this._supportedProps.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var supportedProp = _step2.value;

          if (this._storedProps[supportedProp.name] === undefined) {
            var attr = this._element.getAttribute(supportedProp.attributeName);

            var isDefault = false;

            if (attr === null && supportedProp.defaultValue !== null) {
              attr = supportedProp.defaultValue;
              isDefault = true;
            }

            if (attr !== null && attr !== this._attributes[supportedProp.name]) {
              var parsedValue = this._parsePropValue(supportedProp, attr, isDefault);

              if (parsedValue !== undefined) {
                newProps[supportedProp.name] = parsedValue;
              }
            } else if (attr === null) {
              newProps[supportedProp.name] = this._parsePropNullValue(supportedProp, isDefault);
            }
          } else if (this._storedProps[supportedProp.name] !== undefined && this._storedProps[supportedProp.name] !== this.props[supportedProp.name]) {
            newProps[supportedProp.name] = this._storedProps[supportedProp.name];
            delete this._updatedProps[supportedProp.name];
            delete this._storedProps[supportedProp.name];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (Object.keys(newProps).length > 0) {
        return this.setProps(newProps);
      }

      return false;
    }
    /**
     * Updates element attributes.
     *
     * @throws ComponentException
     * @param {object} changedProps Object with changed props.
     */

  }, {
    key: "setPropsOnElement",
    value: function setPropsOnElement(changedProps) {
      for (var _i = 0, _Object$keys = Object.keys(changedProps); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        var supportedProp = this._supportedProps.get(key);

        if (supportedProp && this.props[key] !== this._updatedProps[supportedProp.name]) {
          this._updatedProps[supportedProp.name] = this.props[supportedProp.name];

          if (this.props[supportedProp.name] !== null && this.props[supportedProp.name] !== undefined) {
            if (supportedProp.type === 'object') {
              var objectId = this._cacheStore.get('objectId') || 0;
              objectId++;

              this._element.setAttribute(supportedProp.attributeName, '#' + objectId);

              this._attributes[supportedProp.name] = '#' + objectId;

              this._cacheStore.set('objectId', objectId);
            } else {
              this._element.setAttribute(supportedProp.attributeName, String(this.props[supportedProp.name]));

              this._attributes[supportedProp.name] = String(this.props[supportedProp.name]);
            }
          } else {
            this._element.removeAttribute(supportedProp.attributeName);
          }
        }
      }
    }
    /**
     * Sets new props and triggers propsWillChange() and propsHasChanged().
     *
     * @param {object} newProps Props to set as key/value. Example: { prop1: 'value1' }.
     * @returns {boolean} Returns TRUE if changed.
     */

  }, {
    key: "setProps",
    value: function setProps(newProps) {
      var changedProps = this.getChangedProps(newProps);

      if (Object.keys(changedProps).length > 0) {
        this.trigger('propsWillChange', changedProps);
        this.props = Object.assign({}, this.props, changedProps); //TODO: Add Object.freeze(this.props) to be sure that the object is immutable.

        this.setPropsOnElement(changedProps);
        this.trigger('propsHasChanged', changedProps);
        return true;
      }

      return false;
    }
    /**
     * Returns changed props based on an object with new props.
     *
     * @param {object} newProps Props to set as key/value. Example: { prop1: 'value1' }.
     * @returns {object} Changed props.
     */

  }, {
    key: "getChangedProps",
    value: function getChangedProps(newProps) {
      var changedProps = {};

      if (newProps) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(newProps); _i2 < _Object$keys2.length; _i2++) {
          var key = _Object$keys2[_i2];

          if (newProps[key] !== this.props[key] && this.props[key] !== undefined) {
            changedProps[key] = newProps[key];
          }
        }
      }

      return changedProps;
    }
    /**
     * Checks if the component has changed element/component name.
     *
     * @returns {boolean} TRUE if changed.
     */

  }, {
    key: "hasChangedComponentName",
    value: function hasChangedComponentName() {
      return this._element.name && this._element.name !== this._componentName || this._element.getAttribute('name') !== this._componentName;
    }
    /**
     * Updates stored props.
     *
     * @throws ComponentException
     * @param {string} uniqueId Unique id.
     */

  }, {
    key: "updateStoredProps",
    value: function updateStoredProps(uniqueId) {
      var storedProps = this._cacheStore.getProps(uniqueId);

      this._cacheStore.removeProps(uniqueId);

      if (storedProps) {
        for (var key in storedProps) {
          if (storedProps.hasOwnProperty(key)) {
            this._storedProps[key] = storedProps[key];
          }
        }
      }
    }
    /**
     * Parses prop value.
     *
     * @throws ComponentException
     * @param {SupportedProp} supportedProp Supported prop.
     * @param {object} attr Attribute.
     * @param {boolean} isDefault TRUE if the value is defaulted.
     * @returns {object|undefined} Parsed value.
     */

  }, {
    key: "_parsePropValue",
    value: function _parsePropValue(supportedProp, attr, isDefault) {
      var parsedValue = undefined;

      if (supportedProp.type === 'object') {
        parsedValue = this._parseObjectProp(supportedProp.name, attr);

        if (!isDefault) {
          this._updatedProps[supportedProp.name] = parsedValue;
          this._attributes[supportedProp.name] = attr;
        }
      } else {
        var newValue = supportedProp.parseValue(attr);

        if (supportedProp.validValues.length > 0 && !supportedProp.validValues.includes(newValue.toString())) {
          throw new _ComponentException.default('The value of prop "' + supportedProp.name + '" is in an invalid format. Only the following values are supported: ' + supportedProp.validValues.join(',') + '.', this._componentName);
        }

        if (newValue !== this.props[supportedProp.name]) {
          parsedValue = newValue;

          if (!isDefault) {
            this._updatedProps[supportedProp.name] = parsedValue;
            this._attributes[supportedProp.name] = attr;
          }
        }
      }

      return parsedValue;
    }
    /**
     * Parses prop null value.
     *
     * @throws ComponentException
     * @param {SupportedProp} supportedProp Supported prop.
     * @param {boolean} isDefault TRUE if the value is defaulted.
     * @returns {object|undefined} Parsed value.
     */

  }, {
    key: "_parsePropNullValue",
    value: function _parsePropNullValue(supportedProp, isDefault) {
      if (supportedProp.isRequired) {
        throw new _ComponentException.default('Failed to update props. The prop with name "' + supportedProp.name + '" (' + supportedProp.attributeName + ') is mandatory.', this._componentName);
      }

      var parsedValue = supportedProp.type === 'object' ? this._parseObjectProp(supportedProp.name, null) : null;

      if (!isDefault) {
        this._updatedProps[supportedProp.name] = parsedValue;
        this._attributes[supportedProp.name] = null;
      }

      return parsedValue;
    }
    /**
     * Parses an object prop.
     *
     * @throws ComponentException
     * @param {string} name Prop name.
     * @param {string} value Value to parse.
     * @returns {object} Parsed value.
     */

  }, {
    key: "_parseObjectProp",
    value: function _parseObjectProp(name, value) {
      var methodName = 'parse' + _StringUtility.default.capitalizeFirstLetter(name);

      var parsedValue = this._objectParser(methodName, value);

      if (parsedValue !== undefined) {
        return parsedValue;
      }

      var supportedProp = this._supportedProps.get(name);

      return supportedProp ? supportedProp.parseValue(value) : null;
    }
  }]);

  return ComponentPropHandler;
}(_EventHandler2.default);

exports.default = ComponentPropHandler;